export default __webpack_public_path__ + "static/media/AE4.bbc009da.jpg";